module.exports = __webpack_public_path__ + "static/media/faim.19ad80a9.jpeg";